import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'
import store from '@/store'
import {Modal, notification} from 'ant-design-vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import router from '@/router'

let apiBaseUrl = window._CONFIG['domianURL'] || "/specialAsset-boot";
// 创建 axios 实例
const service = axios.create({
    //baseURL: '/jeecg-boot',
    baseURL: apiBaseUrl, // api base_url
    timeout: 9000 // 请求超时时间
})
const err = (error) => {
    if (error.response) {
        let data = error.response.data
        const token = Vue.ls.get(ACCESS_TOKEN)
        console.log("------异常响应------",token)
        console.log("------异常响应------",error.response.status)
        switch (error.response.status) {
            case 403:
                notification.error({ message: '系统提示', description: '拒绝访问',duration: 4})
                break
            case 500:
                if( data.message=="Token失效，请重新登录"){
                    // Modal.error({
                    //     title: '登录已过期',
                    //     content: '请登录后在访问',
                    //     okText: '重新登录',
                    //     mask: false,
                    //     onOk: () => {
                    //         router.push('/login')
                    //     }
                    // })
                    router.push('/login')
                }
                break
            case 404:
                notification.error({ message: '系统提示', description:'很抱歉，资源未找到!',duration: 4})
                break
            case 504:
                notification.error({ message: '系统提示', description: '网络超时'})
                break
            case 401:
                notification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
                if (token) {
                    store.dispatch('Logout').then(() => {
                        setTimeout(() => {
                            window.location.reload()
                        }, 1500)
                    })
                }
                break
            default:
                notification.error({
                    message: '系统提示',
                    description: data.message,
                    duration: 4
                })
                break
        }
    }
    return Promise.reject(error)
};

const whitelist = ['']

service.interceptors.request.use(config => {
    if(whitelist.indexOf(config.url)==-1){
        const token = Vue.ls.get(ACCESS_TOKEN)
        if (token) {
            config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
        }
    }
    return config
},(error) => {
    return Promise.reject(error)
})

service.interceptors.response.use((response) => {
    return response.data
  }, err)


const installer = {
    vm: {},
    install (Vue, router = {}) {
        Vue.use(VueAxios, router, service)
    }
}


export {
    installer as VueAxios,
    service as axios
}
